export const PAN_FORMAT_PATTERN = /^[A-Z]{5}\d{4}[A-Z]$/;

/** Valid 4th-character holder types per Indian Income Tax PAN structure */
export const VALID_PAN_HOLDER_TYPES = new Set(["P", "C", "H", "A", "B", "G", "J", "L", "F", "T"]);

/** Example PAN with valid individual holder type (P in 4th position) */
export const EXAMPLE_VALID_PAN = "ABCPP1234F";

export function normalizePanNumber(pan) {
  return String(pan ?? "")
    .trim()
    .replace(/\s+/g, "")
    .toUpperCase();
}

export function validatePanNumber(pan, { required = false } = {}) {
  const normalized = normalizePanNumber(pan);

  if (!normalized) {
    if (required) {
      return { valid: false, error: "PAN card number is required" };
    }
    return { valid: true };
  }

  if (!PAN_FORMAT_PATTERN.test(normalized)) {
    return {
      valid: false,
      error: `Invalid PAN format. PAN should be 10 characters: 5 letters, 4 digits, 1 letter (e.g., ${EXAMPLE_VALID_PAN})`,
    };
  }

  const holderType = normalized.charAt(3);
  if (!VALID_PAN_HOLDER_TYPES.has(holderType)) {
    return {
      valid: false,
      error: `Invalid PAN holder type "${holderType}". Expected a valid 4th character (e.g., P for individual, H for HUF).`,
    };
  }

  return { valid: true, normalized };
}
